export default __webpack_public_path__ + "static/email-7253ca4e64829a996d6941d92eba0962.jpg";